import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Contact from './Contact';
import Exhibitions from './Exhibitions';
import Workshops from './Workshops';
import Gallery from './Gallery';
import Shop from './Shop';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Home from './Home';
import { Nav, Navbar } from "react-bootstrap";

function App() {
  return (
    <div className="App">
      <Navbar sticky="top" bg="light" expand="lg">
        <Navbar.Brand href="/">Sombrero</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
                <Nav.Link href="/gallery" className="underline">Gallery</Nav.Link>
                <Nav.Link href="/exhibitions" className="underline">Exhibitions</Nav.Link>
                <Nav.Link href="/workshops" className="underline">Workshops</Nav.Link>
                <Nav.Link href="/contact" className="underline">Contact</Nav.Link>
                <Nav.Link href="/shop" className="underline">Shop</Nav.Link>
            </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Router>
        <Switch>
          <Route path="/gallery" component={Gallery}></Route>
          <Route path="/exhibitions" component={Exhibitions}></Route>
          <Route path="/workshops" component={Workshops}></Route>
          <Route path="/contact" component={Contact}></Route>
          <Route path="/shop" component={Shop}></Route>
          <Route path="/" component={Home}></Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
